;(function (angular) {
  'use strict'

  angular
    .module('kilo.common.directives')
    .directive('computeLine', computeLineDirective)

  computeLineDirective.$inject = []

  function computeLineDirective () {
    return {
      restrict: 'A',
      replace: true,
      // transclude: true,
      bindToController: true,
      controller: function () {},
      templateUrl: '/app/modules/compute/lines/compute-line.template.html',
      controllerAs: 'notUsed'
    }
  }
})(window.angular)
